import React from 'react';
import style from './Table.module.css';

const Table = ({ children }) => {
  return (
    <table className={style.table}>
      {children}
    </table>
  );
};

export default Table;
